var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTemperatureStep = function SvgTemperatureStep(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    style: {
      color: "#2d4e6d"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.636 1.194a7.317 7.317 0 0 0-7.823 11.994 7.317 7.317 0 0 0 12.139-2.934 7.317 7.317 0 0 0-.146-4.89.65.65 0 0 0-1.211.471A6.017 6.017 0 1 1 2.002 8.637a6.017 6.017 0 0 1 8.163-6.231.65.65 0 0 0 .47-1.212Zm2.49 2.599a.65.65 0 1 0-.918-.92L8.866 6.216a1.983 1.983 0 1 0 .92.92l3.34-3.342ZM8.002 7.317a.68.68 0 0 1 .411.137.655.655 0 0 0 .134.135A.683.683 0 1 1 8 7.317Z",
    clipRule: "evenodd"
  })));
};
export default SvgTemperatureStep;